"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var View = function () {
  function View() {
    _classCallCheck(this, View);
  }

  _createClass(View, [{
    key: "styleNames",
    get: function get() {
      return this.constructor._styles;
    }
  }, {
    key: "translations",
    get: function get() {
      return this.constructor._translations;
    }
  }], [{
    key: "extendStyleNames",
    value: function extendStyleNames(styles) {
      this._styles = _extends({}, this._styles, styles);
    }
  }, {
    key: "extendTranslations",
    value: function extendTranslations(translations) {
      this._translations = _extends({}, this._translations, translations);
    }
  }]);

  return View;
}();

View._styles = {};
View._translations = {};
exports.default = View;
//# sourceMappingURL=view.js.map



//////////////////
// WEBPACK FOOTER
// ./~/video-player/dist/src/ui/core/view.js
// module id = 155
// module chunks = 1 2 3